var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1491 8.96136H9.52357L9.30185 8.74756C9.79671 8.17266 10.1584 7.49549 10.361 6.76449C10.5636 6.0335 10.6021 5.26676 10.4738 4.51915C10.1016 2.31784 8.26454 0.559957 6.0474 0.290732C5.26792 0.192121 4.47622 0.273131 3.73287 0.527562C2.98952 0.781993 2.31423 1.2031 1.75867 1.75867C1.2031 2.31423 0.781993 2.98952 0.527562 3.73287C0.273131 4.47622 0.192121 5.26792 0.290732 6.04739C0.559957 8.26454 2.31784 10.1016 4.51915 10.4738C5.26676 10.6021 6.0335 10.5636 6.76449 10.361C7.49549 10.1584 8.17266 9.79671 8.74756 9.30185L8.96136 9.52356V10.1491L12.3267 13.5144C12.6513 13.8391 13.1819 13.8391 13.5065 13.5144C13.8312 13.1898 13.8312 12.6592 13.5065 12.3346L10.1491 8.96136ZM5.39809 8.96136C3.42641 8.96136 1.83482 7.36976 1.83482 5.39809C1.83482 3.42641 3.42641 1.83482 5.39809 1.83482C7.36977 1.83482 8.96136 3.42641 8.96136 5.39809C8.96136 7.36976 7.36977 8.96136 5.39809 8.96136Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e249da6524745ea3778e089765fdde5a.svg";
export { ForwardRef as ReactComponent };